import { createSelector } from 'reselect';

import { getCountryCode } from '../../utils/locations';

const getBillingInfo = (store) => store.apps.billing.billingInfo;
const getUser = (store) => store.user;

const billingInfoSelector = createSelector(
  [getBillingInfo],
  (billingInfo) => ({
    accountInRecurlyExists: billingInfo.get('accountInRecurlyExists'),
    email: billingInfo.get('email'),
    isLoading: billingInfo.get('isLoading'),
    paymentInfo: billingInfo.get('paymentInfo'),
    paymentInfoCurrent: billingInfo.get('paymentInfoCurrent'),
    paymentMethod: billingInfo.get('paymentMethod'),
    paymentMethodCurrent: billingInfo.get('paymentMethodCurrent'),
    token: billingInfo.get('token'),
  }),
);

// Returns credit card information saved in Recurly
const creditCardInfoSelector = createSelector(
  [getBillingInfo],
  (billingInfo) => {
    const paymentMethod = billingInfo?.get('paymentMethod');
    return {
      cardType: paymentMethod?.cardType,
      lastFour: paymentMethod?.lastFour,
      expires: paymentMethod?.expires,
      isValid: paymentMethod?.isValid,
    };
  },
);

const recurlyInstanceSelector = createSelector(
  getUser,
  (user) => user.getRecurlyInstance(),
);

const hasPastDueInvoiceSelector = createSelector(
  getBillingInfo,
  (billingInfo) => billingInfo.get('hasPastDueInvoice'),
);

const initialValuesSelector = createSelector(
  [billingInfoSelector, getUser],
  (billingInfo, user) => {
    const paymentInfo = billingInfo.paymentInfoCurrent || billingInfo.paymentInfo;
    return {
      ...paymentInfo,
      company: paymentInfo?.company || user.organization.name,
      country: paymentInfo?.country || getCountryCode(user.organization?.settings?.country),
      creditCard: false,
      email: paymentInfo?.email || user.email,
      firstName: paymentInfo?.firstName || user.first_name,
      lastName: paymentInfo?.lastName || user.last_name,
    };
  },
);

const paymentFormSelector = createSelector(
  [billingInfoSelector, initialValuesSelector, recurlyInstanceSelector],
  (billingInfo, initialValues, recurlyInstance) => ({
    ...billingInfo,
    initialValues,
    recurlyInstance,
  }),
);

const cardDetailsSelector = createSelector(
  [getBillingInfo],
  (billingInfo) => billingInfo?.get('cardDetails'),
);

const cardValidSelector = createSelector(
  [getBillingInfo],
  (billingInfo) => billingInfo?.get('cardValid'),
);

export default billingInfoSelector;
export {
  billingInfoSelector,
  initialValuesSelector,
  creditCardInfoSelector,
  getBillingInfo,
  hasPastDueInvoiceSelector,
  paymentFormSelector,
  cardDetailsSelector,
  cardValidSelector,
};
